import { useEffect, useState } from "react";
import { Button, Modal, Box, TextField, Typography } from "@mui/material";
import BookingService from "../../../services/api/booking.service";
import { ISelectedDay } from "../../../models/entities/ISelectedDay";
import AuthService from "../../../services/api/auth.service";

const DayLock = () => {
  const [days, setDays] = useState<ISelectedDay[]>([]);
  const [open, setOpen] = useState(false);
  const [newDate, setNewDate] = useState("");
  const [token, setToken] = useState<any>("");


  useEffect(() => {
    if (AuthService.getUserConnected() != "" || AuthService.getUserConnected() != null) {
      setToken(AuthService.getUserConnected());
      fetchDays();
    }
  }, [token]);

  const fetchDays = async () => {
    try {
      const response = await BookingService.getAllBlockedDay(token);
      setDays(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des jours :", error);
    }
  };

  const handleAddDay = async () => {
    if (!newDate) return;
    try {
      await BookingService.postBlockedDay({ date: newDate }, token);
      setNewDate("");
      setOpen(false);
      fetchDays();
    } catch (error) {
      console.error("Erreur lors de l'ajout :", error);
    }
  };

  const handleDeleteDay = async (id: number) => {
    try {
      await BookingService.removeBlockedDay(id, token);
      fetchDays();
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  return (
    <div className="selected-day-container">
      <div className="selected-day-align">
        <Typography variant="h4">Jours Bloqués</Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>Ajouter un Jour</Button>
      </div>
      <ul>
        {days.map((day) => (
          <li key={day.id}>
            {day.date}
            <Button color="error" onClick={() => handleDeleteDay(day.id)}>Supprimer</Button>
          </li>
        ))}
      </ul>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box className="modal-box">
          <Typography variant="h6" style={{marginBottom:10}}>Ajouter un Jour a Bloqué</Typography>
          <TextField
            type="date"
            value={newDate}
            onChange={(e) => setNewDate(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={handleAddDay}>Ajouter</Button>
        </Box>
      </Modal>
    </div>
  );
};

export default DayLock;
